import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src3540671299/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
